/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_StatusInputs */

const cs_tasks_protocol_status = /** @type {(inputs: Tasks_Protocol_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav podpisu`)
};

const en_tasks_protocol_status = /** @type {(inputs: Tasks_Protocol_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing status`)
};

/**
* | output |
* | --- |
* | "Signing status" |
*
* @param {Tasks_Protocol_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_status = /** @type {((inputs?: Tasks_Protocol_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_status(inputs)
	return cs_tasks_protocol_status(inputs)
});